import axios from 'axios'
import { i18n } from '@/main.js' 
import router from '@/router.js'

export default({
    state: {
        formulationsByQuestion: [],
        formulationsByTest: [],

        testQuestions: [], // Questions in currently selected test. Used when adding questions, to show which are already selected
    },

    getters: {
        getFormulationsByQuestion(state){ return state.formulationsByQuestion },
        getFormulationsByTest(state){ return state.formulationsByTest },

        getTestQuestions(state){ return state.testQuestions },
    },

    mutations: {
        setFormulationsByQuestion(state, value){ state.formulationsByQuestion = value },
        setFormulationsByTest(state, value){
            state.formulationsByTest = value
            state.testQuestions = value.map(formulation => formulation.question.id)
        },

        setTestQuestions(state, value){ state.testQuestions = value },
    },

    actions: {
        getFormulationsByQuestion({ commit }, questionId){
            commit('setLoading')
            commit('setFormulationsByQuestion', [])
            return new Promise(() => {
                axios.get('/formulations/question/' + questionId)
                .then((response) =>{
                    commit('setFormulationsByQuestion', response.data)
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        getFormulationsByTest({ commit }, testId){
            commit('setLoading')
            return new Promise((resolve) => {
                axios.get('/formulations/test/' + testId)
                .then((response) =>{
                    commit('setFormulationsByTest', response.data)
                    resolve(response.data)
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        updateFormulations({ state, commit }){
            commit('setLoading')
            
            return new Promise((resolve) => {
                axios.put('/formulations', state.formulationsByTest)
                .then(() => {
                    commit('setSnackBar', {value: true, text: i18n.t('indexesInserted'), color: 'green'})
                    resolve()
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        addFormulation({ state, commit, dispatch }, formulation ){
            commit('setLoading')

            return new Promise(() => {
                axios.post('/formulations', formulation)
                .then((response) => {
                    dispatch('getFormulationsByTest', formulation.testId)
                    commit('setSnackBar', {value: true, text: i18n.t('questionAdded'), color: 'green'})
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        deleteFormulation({ state, commit, dispatch }, questionId){
            commit('setLoading')
            var formulation = state.formulationsByTest.find(formulation => formulation.question.id == questionId)

            return new Promise(() => {
                axios.delete('/formulations/' + formulation.id)
                .then(() => {
                    dispatch('getFormulationsByTest', formulation.test.id)
                    .then((testQuestions) => {
                        if (router.currentRoute.name == 'Test')
                            commit('setQuestions', testQuestions.map(formulation => formulation.question))
                    })
                    commit('setSnackBar', {value: true, text: i18n.t('questionDeleted'), color: 'green'})
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        moveFormulation({ state, commit, dispatch }, { oldPosition, newPosition }){
            commit('setLoading')
            var formulation = state.formulationsByTest.find(formulation => formulation.position == oldPosition)

            return new Promise(() => {
                axios.put('/formulations/' + formulation.id + '/move/' + newPosition)
                .then(() => {
                    dispatch('getFormulationsByTest', formulation.test.id)
                    .then((testQuestions) => {
                        commit('setQuestions', testQuestions.map(formulation => formulation.question))
                    })
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },
    },
});
